import {Address} from '../../admin/artisticobjects/types/Address';

/**
 * Formats an Address object into a readable string representation
 * @param address - The address object to format
 * @returns Formatted address string or undefined if address is null/undefined
 */
export const formatAddress = (address?: Address | null): string | undefined => {
  if (!address) {
    return undefined;
  }

  const parts: string[] = [];

  // Street and number
  if (address.street) {
    let streetPart = address.street;
    if (address.streetNumber) {
      streetPart += ` ${address.streetNumber}`;
    }
    if (address.apartmentNumber) {
      streetPart += `/${address.apartmentNumber}`;
    }
    parts.push(streetPart);
  }

  // Town and postal code
  if (address.town) {
    let townPart = address.town;
    if (address.postalCode) {
      townPart = `${address.postalCode} ${townPart}`;
    }
    parts.push(townPart);
  }

  // Administration unit
  if (address.administrationUnit?.name) {
    parts.push(address.administrationUnit.name);
  }

  return parts.length > 0 ? parts.join(', ') : undefined;
};
